import { FC, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import TopNav from "../../components/TopNav/TopNav";
import Button from "../../components/Button/Button";
import Title from "../../components/Title/Title";
import { UpdateIcon } from "../../components/icons/UpdateIcon";
import ContentLayout from "../../layout/ContentLayout/ContentLayout";
import { fetchModels } from "../../store/models/slice";
import { upgradeSubscription } from "../../store/auth/slice";
import {
  selectModelLoading,
  selectModelsLoadError,
  selectActiveModelsForSubscriptionPlanState,
  selectInactiveModelsForSubscriptionPlanState,
  selectModelsOutsideSubscriptionPlanState,
} from "../../store/selectors/models";
import CardSwitchModelsWrapper from "../../components/CardSwitchModelsWrapper/CardSwitchModelsWrapper";

import styles from "./SettingModels.module.css";



const SettingModelsView: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const loading = useSelector(selectModelLoading);
  const modelsError = useSelector(selectModelsLoadError);
  const activeModels = useSelector(selectActiveModelsForSubscriptionPlanState);
  const inactiveModels = useSelector(selectInactiveModelsForSubscriptionPlanState);
  const modelsOutsidePlan = useSelector(selectModelsOutsideSubscriptionPlanState);

  useEffect(() => {
    dispatch(fetchModels());
  }, [dispatch]);

  const handleUpgrade = () => {
    dispatch(upgradeSubscription());
  };

  const closePromptsSettings = () => {
    navigate(-1);
  };

  const renderTopNavRightContent = () => {
    return (
      <div className={styles["modal"]}>
        {loading && <p className={styles["modal__changed"]}><UpdateIcon /> changes saved</p>}
        <Button label="Close" onClick={closePromptsSettings} />
      </div>
    );
  };

  return (
    <>
      <TopNav title="Models Settings" rightContent={renderTopNavRightContent()} />

      <ContentLayout>
        <Title className={styles["title"]} label="Active Models" />
        <CardSwitchModelsWrapper
          models={activeModels}
          active={true}
          skeletonCount={3}
          loading={loading}
          error={modelsError}
          onRetry={() => dispatch(fetchModels())}
        />

        {inactiveModels && inactiveModels.length > 0 && <Title className={styles["title"]} label="Inactive Models" />}
        <CardSwitchModelsWrapper
          models={inactiveModels}
          active={false}
          skeletonCount={3}
          loading={loading}
          error={modelsError}
          onRetry={() => dispatch(fetchModels())}
        />

        {modelsOutsidePlan && modelsOutsidePlan.length > 0 && (
          <>
            <Title className={styles["title"]} label="Advanced plan models" />
            <CardSwitchModelsWrapper
              models={modelsOutsidePlan}
              active={false}
              skeletonCount={3}
              loading={loading}
              error={modelsError}
              onRetry={() => dispatch(fetchModels())}
              planLocked
              onUpgrade={handleUpgrade}
            />
          </>
        )}

      </ContentLayout>
    </>
  );
}

export default SettingModelsView;
